import React from 'react';
import Amplify, {Auth} from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAllSettlement } from '../../../Actions/actions';
import * as SecretKeys from '../../../ENV.json';
import SubuserBusiness from './subuserBusiness';


Amplify.configure(SecretKeys.awsUserpool);
const userid = localStorage.getItem('userId');

class SubuserBusinessContainer extends React.Component {
  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending') {
      localStorage.clear();
      Auth.signOut().then(async () => {
        await this.props.logoutUser();
        this.props.clearDataEmail();
        this.context.router.history.push('/');
      }).catch(error => error);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      // this.forceUpdate();
      return true;
    }
    return false;
  }

  saveEnrichmentAnswer(queId, ans) {
    const data = { userId: userid, value: ans, enrichmentQuestionId: queId };
    this.props.saveEnrichmentAnswer(data);
  }

  render() {
    // const {} = this.state;

    return (
      <div className="container">
        <div className="main-content bg-grey">
          <SubuserBusiness />
        </div>
      </div>
    );
  }
}

SubuserBusinessContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllSettlement }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubuserBusinessContainer));
